import React, { useState, useEffect } from "react";

import AdminToolsDataService from "../../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import { Spin, Switch, Table, Tooltip } from "antd";


const DiamondRapNetPermission = () => {
  const { t } = useTranslation();
  const [diamondRapNetPermissionData, setDiamondRapNetPermission] = useState(
    []
  );
  const [loading, setLoading] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(1000);

  useEffect(() => {
    GetDiamondImportRightsList(pageNo, pageSize);
  }, []);

  const GetDiamondImportRightsList = (pageNo, pageSize) => {
    let inputData = {
      pageNumber: pageNo,
      pageSize: pageSize,
    };
    setLoading(true);
    AdminToolsDataService.GetDiamondImportRightsList(inputData)
      .then((response) => {
        setLoading(false);
        var message = response.data.message;
        var responseData = response.data.responseData.thirdPartyDiamond;
        var totalCount = response.data.responseData.totalRecord;
        if (message === "Success") {
          setDiamondRapNetPermission(responseData);
          setTotalCount(totalCount);
        } else {
          setDiamondRapNetPermission([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOnChange = (row, e, name) => {
    const temp = diamondRapNetPermissionData.map((x) => {
      if (x.dealerID == row.dealerID) {
        return { ...x, enabled: e };
      } else return x;
    });
    setDiamondRapNetPermission(temp);
    var item = temp.filter((item) => item.dealerID == row.dealerID)[0];
    handleSubmit(item);
  };

  const handleSubmit = (item) => {
    let inputData = {
      dealerID: Number(item.dealerID),
      enabled: item.enabled,
    };
    setLoading(true);
    AdminToolsDataService.SaveDiamondImportRights(inputData)
      .then((response) => {
        var message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Data Updated Successfully."));
          GetDiamondImportRightsList(pageNo, pageSize);
        } else {
          NotificationManager.success(t("Data Not Updated."));
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  function handlePageNoChange(page, pageSize) {
    setPageNo(page);
    GetDiamondImportRightsList(page, pageSize);
  }
  function handlePageSizeChange(current, size) {
    setPageSize(size);
    GetDiamondImportRightsList(current, size);
  }

  return (
    <React.Fragment>
      <div className="diamond_section">
        <div className="form__fields">
          <div className="row">
            <div className="col-md-12">
              <h4 className="workarea__heading mt-0 mb-0">
                {t("Enable 3rd Party Diamond Imports")}
              </h4>
            </div>
            <div className="col-md-12 mt-4">
              <div className="dealer_tbldiv table__scroll">
                <Spin spinning={loading} size="large">
                  <Table
                    scroll={{ y: "calc(100vh - 340px)" }}
                    columns={[
                      {
                        dataIndex: "dealerID",
                        title: (
                          <Tooltip title={t("Dealer ID")}>
                            {t("Dealer ID")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                      },
                      {
                        dataIndex: "dealerName",
                        title: (
                          <Tooltip title={t("Dealer Name")}>
                            {t("Dealer Name")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                      },
                      {
                        dataIndex: "dealerCompany",
                        title: (
                          <Tooltip title={t("Dealer Company")}>
                            {t("Dealer Company")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                      },
                      {
                        dataIndex: "enabled",
                        title: (
                          <Tooltip title={t("Enabled")}>{t("Enabled")}</Tooltip>
                        ),
                        ellipsis: true,
                        Key: "completed",
                        render: (item, row) => {
                          return (
                            <Switch
                              checkedChildren={t("Yes")}
                              unCheckedChildren={t("No")}
                              checked={row.enabled}
                              onChange={(e) =>
                                handleOnChange(row, e, "enabled")
                              }
                            />
                          );
                        },
                      },
                    ]}
                    onChange={(pagination, filters, sorters) => {
                      var tableBody = document.querySelector(".table__scroll .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
                    }}
                    pagination={{
                      size: "small",
                      total: totalCount,
                      pageNo: pageNo,
                      pageSize: pageSize,
                      pageSizeOptions: [10, 15, 20, 50, 100],
                      responsive: true,
                      showSizeChanger: true,
                      onChange: handlePageNoChange,
                      onShowSizeChange: handlePageSizeChange,
                    }}
                    dataSource={diamondRapNetPermissionData}
                  />
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondRapNetPermission;
